import { Backdrop } from "components";
import { AiOutlineClose } from "react-icons/ai";
import { Card, CardBody } from "reactstrap";
import "./styles.css";

const ImageModal = ({ open, hideModal, children, zIndex = 0 }) => {
	return (
		<Backdrop hide={hideModal} open={open} style={{ zIndex: 9999 + zIndex }}>
			<Card
				onClick={(e) => e.stopPropagation()}
				className="text-center image-modal"
				style={{
					maxHeight: "75vh",
					overflowY: "auto",
					position: "relative",
				}}
			>
				<div
					style={{
						position: "fixed",
						top: 5,
						right: 10,
						padding: 3,
						cursor: "pointer",
					}}
				>
					<AiOutlineClose size={20} color="white" onClick={hideModal} />
				</div>
				<CardBody>{children}</CardBody>
			</Card>
		</Backdrop>
	);
};

export default ImageModal;
